import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SecondaryButtonStyled } from '~/styles';

export const ReturnToolDetailHeader = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
})`
  width: 100%;
`;

export const ReturnToolDetailBodyStyled = styled(Box)`
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: 'Open-sans';
`;

export const ReturnDetailContainerStyled = styled(Box)`
  height: calc(100vh - 228px);
  flex-direction: column;
  overflow-y: auto;
`;

export const FooterStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  justifyContent: { sm: 'flex-end' },
  gap: { sm: '500' },
})`
  width: 100%;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadowInverted};
`;

export const CancelButtonStyled = styled(SecondaryButtonStyled)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[400]};
    padding: ${theme.spacings[400]} ${theme.spacings[600]};
  `}
`;
